import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/markdown-document-screen';
import { PRIVACY_POLICY } from './Constants.ts';
import privacyPolicy from './fans-fund-me-privacy-policy-26022025.md';

function PrivacyPolicy() {
  return <Screen title={PRIVACY_POLICY.TITLE_TEXT} subtitle={PRIVACY_POLICY.SUBTITLE_TEXT} content={privacyPolicy} />;
}

export default PrivacyPolicy;
